// src/components/VideoPlayer.jsx
import React, { useEffect, useState, useCallback } from "react";
import { ClipLoader } from "react-spinners";
import VideoPlayer from "./studio/VideoPlayer";
import CategoryList from "./studio/CategoryList";
import FilmGrid from "./studio/FilmGrid";
import { supabase } from "../services/supabase";
import { useParams } from "react-router-dom";
import BackHome from "./studio/BackHome";
function Studio() {
    const { id } = useParams();
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [films, setFilms] = useState([]);
    const [currentFilm, setCurrentFilm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [totalFilms, setTotalFilms] = useState(0);

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        if (selectedCategory) {
            fetchFilms();
        }
    }, [selectedCategory]);

    const handleVideoEnd = useCallback(() => {
        // Tìm index của video hiện tại
        const currentIndex = films.findIndex((film) => film.id === currentFilm?.id);

        // Tính toán index của video tiếp theo
        const nextIndex = currentIndex + 1;

        // Kiểm tra và set video tiếp theo
        if (nextIndex < films.length) {
            const nextVideo = films[nextIndex];
            setCurrentFilm(nextVideo);
        }
    }, [films, currentFilm]);

    const fetchCategories = async () => {
        debugger;
        const { data, error } = await supabase
            .from("categories")
            .select("*")
            .eq("parentid", parseInt(id));
        if (data) setCategories(data);
    };

    const fetchFilms = async () => {
        setLoading(true);
        const { data, error } = await supabase
            .from("media")
            .select("*")
            .eq("categoryid", selectedCategory.id)
            .order("id", { ascending: true });

        if (data) {
            setFilms(data);
            setTotalFilms(data.length); // Cập nhật tổng số phim
        }
        setLoading(false);
    };

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
    };

    const handleFilmSelect = (film) => {
        setCurrentFilm(film);
    };
    return (
        <>
            <BackHome />
            <VideoPlayer film={currentFilm} onVideoEnd={handleVideoEnd} />
            <CategoryList
                categories={categories}
                selectedCategory={selectedCategory}
                onSelectCategory={handleCategorySelect}
            />
            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <ClipLoader size={50} color={"#e74c3c"} loading={loading} />
                </div>
            ) : (
                <FilmGrid films={films} onSelectFilm={handleFilmSelect} />
            )}
        </>
    );
}

export default Studio;
